<template>
    <div>
        <div :class="['parametric', {
            'is-ready': isReady,
            'is-overlay': isFilterOpen
        }]">
            <Results />
            <Filters :isFilterOpen="isFilterOpen"
                     ref="filter"
                     v-on:close="isFilterOpen = false"
                     @openModal="openGenplan"
            />
        </div>
        <GenplanPopup ref="genplanModal" @sendBuilding="buildingSelect"></GenplanPopup>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Filters from './Filters/Filters.vue';
import GenplanPopup from './Genplan-popup/GenplanPopup.vue';
import Observer from 'common/scripts/observer';
import Results from './Results/Results.vue';

const observer = new Observer();


export default {
    data: () => {
        return {isFilterOpen: false};
    },

    components: {
        Filters,
        GenplanPopup,
        Results
    },

    computed: {...mapGetters({isReady: 'GET_IS_READY'})},

    methods: {...mapActions(['initApp']),
        openGenplan() {
            this.$refs.genplanModal.openModal();
        },
        buildingSelect() {
            this.$refs.filter.change();
        },
        openFilter() {
            this.isFilterOpen = true;
        }
    },

    mounted() {
        const body = {type: 'init'};

        this.initApp(body);

        observer.subscribe('openFilter', () => {
            this.openFilter();
        });
    }
};
</script>
